import React, {useState, useRef, useEffect} from 'react';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAlignLeft, faArrowRightLong } from "@fortawesome/free-solid-svg-icons"; 
import {Link, useNavigate} from "react-router-dom";
import Rightbar from './Rightbar';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { useSelector} from 'react-redux';
import { createBoothDetails } from '../../Service';
import { boothDetailsByEvent } from '../../Service';
import { MultiSelect } from "react-multi-select-component";
import { useParams } from "react-router";
import Multiselect from 'multiselect-react-dropdown';

export default function BoothDetails() {
    const [sidebar, setsidebar] = useState(false);
    const [mainbar, setmainbar] = useState(false);;
    const [selectedValue, setSelectedValue] = useState([]);
    const [namessel, setNames] = useState([]);
    const toggle = () => {
        setsidebar(!sidebar);
        setmainbar(!mainbar);
    }
    const [date, setDate] = useState(new Date());
    const [images, setImages] = React.useState([]);
      const maxNumber = 69;
    
      const onChange = (imageList, addUpdateIndex) => {
        // data for submit
        console.log(imageList, addUpdateIndex);
        setImages(imageList);
      };
      const [selected, setSelected] = useState([]);
      const options = [

        { label: "Select1", value: "select1" },
    
        { label: "Select2", value: "select2" },
    
      ];
      // my code ref
      const navigation = useNavigate();
      let loggedUser = useSelector(store => store.user['user']);
      let user_id = '';
      if(loggedUser){
        user_id = loggedUser.id  
      }
      const [list, setList] = useState([]);
      const initialValues={'key':"contemporaray"};
      const [listMulti, setListMulti] = useState([]);
      const [formValues, setFormValues] = useState([]);
      const [formErrors, setFormErrors] = useState({});
      //const event_id = (new URLSearchParams(window.location.search)).get("event_id");
      const { id } = useParams();
      const event_id  = id;
      const getSelectedItems = useRef();

      console.log(formValues.artwork_type);

      useEffect(() => {
        var userDataForm = new FormData();
        userDataForm.append('user_id', user_id);
        userDataForm.append('event_id', event_id);
        boothDetailsByEvent(userDataForm).then(res => setHandleExhibitorResponse(res))
      },[]);

      const setHandleExhibitorResponse = (res) => 
      {
        setList(res.data.data);
        setListMulti(res.data.data.multi_drop);
        console.log(res.data.data.multi_seleted);
        setFormValues(res.data.data);
        setSelectedValue(res.data.data.multi_seleted);
      }
      

      const hanldeChange = (e) => {
        const value=e.target.value;
        const field=e.target.name;
        setFormValues(prevState => ({
        ...prevState,
        [field]: value }));
        }


    const handleSubmit = (e) => {

        
        let Total_tolamount ='';
        if(formValues.booth_type==1)
        {
            Total_tolamount = (7000*10/100)+200;
        }
        if(formValues.booth_type==2)
        {
            Total_tolamount = (10500*10/100)+200;
        }
        if(formValues.booth_type==3)
        {
            Total_tolamount = (13200*10/100)+200;
        }
        if(formValues.booth_type==4)
        {
            Total_tolamount = (16000*10/100)+200;
        }
        if(formValues.booth_type==5)
        {
            Total_tolamount = (30000*10/100)+200;
        }
        
        localStorage.setItem('paypal_total_amount', Total_tolamount);
        e.preventDefault();
        const errorCount = validate(formValues);
        setFormErrors(errorCount);
        console.log(errorCount)
        console.log(errorCount)
        if(errorCount.status){
        var bodyFormData = new FormData();
        bodyFormData.append('applicant_type', formValues.applicant_type);
        bodyFormData.append('artwork_type', selectedValue ? selectedValue : formValues.artwork_type);
        bodyFormData.append('application_type', formValues.application_type);
        bodyFormData.append('booth_type', formValues.booth_type);
        // bodyFormData.append('booth_details', formValues.booth_details);
        bodyFormData.append('intended_approach', formValues.intended_approach);
        bodyFormData.append('current_years_gallery', formValues.current_years_gallery);
        bodyFormData.append('list_of_artists', formValues.list_of_artists);
        bodyFormData.append('user_id', user_id);
        bodyFormData.append('event_id', event_id);
        createBoothDetails(bodyFormData).then(res => handleResponse(res))
        }
    }

    const handleResponse = (response) => {
        console.log("response 78",response)
        if(response.status==200)
        {
            navigation("/uploadartwork/"+event_id);
            window.scrollTo(0, 0);
        }
        else
        {
            navigation('/boothDetails/'+event_id);
            window.scrollTo(0, 0);
        }
    }

    const validate = (values) => 
        {
            
            const errors = {};
            errors.status = true;
            var error_val=0;
            if(!values.applicant_type){
                errors.applicant_type = 'Required';
                error_val = 1;
            }

            if(!selectedValue){
                errors.artwork_type = 'Required';
                error_val = 1;
            }

            if(!values.application_type){
                errors.application_type = 'Required';
                error_val = 1;
            }

            if(!values.booth_type){
                errors.booth_type = 'Required';
                error_val = 1;
            }

            // if(!values.booth_details){
            //     errors.booth_details = 'Required';
            //     error_val = 1;
            // }

            if(!values.intended_approach){
                errors.intended_approach = 'Required';
                error_val = 1;
            }

            if(!values.current_years_gallery){
                errors.current_years_gallery = 'Required';
                error_val = 1;
            }

            if(!values.list_of_artists){
                errors.list_of_artists = 'Required';
                error_val = 1;
            }
            
            
            if(error_val===1)
            {
                errors.status=false;
            }
            else
            {
                errors.status=true;
            }
            return errors;
        }

          // set value for default selection

          function custom(e){
            var selected_keys =[];
            console.log(e);
            e.forEach(element => {
                selected_keys.push(element.key);
                setSelectedValue(selected_keys);
            });

            }


      /// end //
    return(
      <>
 
<section className="sec-container" >
   <div className='container'>
      <div className='portalevent'>
         <div className='row'>
            <div className={`col-md-3 portal-sidebar leftbar-close ${sidebar ? 'close' : ''}`}>
                  <div >
                  <Rightbar event_id={event_id}/>
                  </div>
               </div>
               <div className={`col-md-9 rightbar-open ${mainbar ? 'open' : ''}`}>
                  <div className='rightbar '>
                  <Button variant="outline-info" onClick={toggle}>
                    <FontAwesomeIcon icon={faAlignLeft} />
                  </Button>
                  <h1>EXHIBITOR DETAILS</h1>                            
                            <div>
                            <p className='red'>Fill out all required fields to complete application.</p>
                            <p className='red'> Note: Any Changes to your booth must be submitted to <Link  className='red' to="mailto:er@photola.com" target="_blank">er@photola.com</Link> for approval. </p>
                            </div>
                            <Form>
                                <Form.Group>
                                    <Form.Label>Are you a new applicant or returning gallery? <span className='star'>*</span></Form.Label>
                                    <Form.Select aria-label="new applicant or returning gallery?" name="applicant_type" defaultValue={formValues.applicant_type}  onChange={hanldeChange}>
                                        <option>Please Select... </option>
                                        <option value="1" selected={list.applicant_type=="1" ? "selected" : ""}>New Applicant</option>
                                        <option value="2" selected={list.applicant_type=="2" ? "selected" : ""}>Returning Gallery</option>
                                    </Form.Select>
                                    <p className="error">{formErrors.applicant_type}</p>
                                </Form.Group>
                                <Form.Group>
                                    <Form.Label  className='red'>What type of artwork are you planning to exhibit? (Check all that apply) <span className='star'>*</span> </Form.Label>

 <Multiselect
  name="artwork_type"
  displayValue="key"
  onKeyPressFn={function noRefCheck(){}}
  onRemove={custom}
  onSearch={function noRefCheck(){}}
  onSelect={custom}
  options={[

        {
          key: 'contemporary'
        },
        {
          key: 'classic'
        },
        {
          key: 'photo-based work'
        },
        {
          key: 'film/video'
        },
        {
          key: 'vernacular'
        }
       
  ]}
  selectedValues={listMulti}

  //selectedValues={listMulti}

  showCheckbox
/>
                                    <p className="error">{formErrors.artwork_type}</p>
                                    {/* <MultiSelect options={options}value={selected}onChange={setSelected}labelledBy="Select"/> */}
                                </Form.Group>
                               <Row>
                               <Col>
                                <Form.Group>
                                    <Form.Label>Booth Type <span className='star'>*</span> </Form.Label>
                                    <Form.Select aria-label="new applicant or returning gallery?" name="application_type" defaultValue={formValues.application_type}  onChange={hanldeChange}>
                                    <option value="">Please Select... </option>
                                    <option value="solo" selected={list.application_type=="solo" ? "selected" : ""}>SOLO BOOTH</option>
                                        <option value="multi" selected={list.application_type=="multi" ? "selected" : ""}>MULTI ARTIST BOOTH</option>
                                        {/* <option value="photo-based work" selected={list.application_type=="photo-based work" ? "selected" : ""}>photo-based work</option>
                                        <option value="film/video" selected={list.application_type=="film/video" ? "selected" : ""}>film/video</option>
                                        <option value="vernacular" selected={list.application_type=="vernacular" ? "selected" : ""}>vernacular</option> */}
                                    </Form.Select>
                                    <p className="error">{formErrors.application_type}</p>
                                </Form.Group>
                                </Col>
                                <Col>
                                <Form.Group>
                                    <Form.Label>Application Type <span className='star'>*</span> </Form.Label>
                                    <Form.Select aria-label="new applicant or returning gallery?" name="booth_type" defaultValue={formValues.booth_type}  onChange={hanldeChange}>
                                        <option>Please Select... </option>
                                        <option value="1" selected={list.booth_type=="1" ? "selected" : ""}> Salon(12'×12'/3.7m×3.7m) $7,000 USD</option>
                                        <option value="2" selected={list.booth_type=="2" ? "selected" : ""}> Standard (12'×16'/3.7m×4.9m) $10,500 USD</option>
                                        <option value="3" selected={list.booth_type=="3" ? "selected" : ""}> Medium (12'×20'/3.7m×6.1m) $13,200 USD</option>
                                        <option value="4" selected={list.booth_type=="4" ? "selected" : ""}> Large (12'×24'/3.7m×7.3m) $16,000 USD</option>
                                        <option value="5" selected={list.booth_type=="5" ? "selected" : ""}> Ex-Large (24'×24'/7.3m×7.3m) $30,000 USD</option>
                                    </Form.Select>
                                    <p className="error">{formErrors.booth_type}</p>
                                </Form.Group>
                                </Col>
                                {/* <Col>
                                <Form.Group>
                                    <Form.Label>Booth Details<span className='star'>*</span> </Form.Label>
                                    <Form.Select aria-label="new applicant or returning gallery?" name="booth_details" defaultValue={formValues.booth_details}  onChange={hanldeChange}>
                                        <option>Please Select... </option>
                                        <option value="1" selected={list.booth_details=="1" ? "selected" : ""}>booth_details 1</option>
                                        <option value="2" selected={list.booth_details=="2" ? "selected" : ""}>booth_details 2</option>
                                        <option value="3" selected={list.booth_details=="3" ? "selected" : ""}>booth_details 3</option>
                                        <option value="4" selected={list.booth_details=="4" ? "selected" : ""}>booth_details 4</option>
                                        <option value="5" selected={list.booth_details=="5" ? "selected" : ""}>booth_details 5</option>
 
                                    </Form.Select>
                                    <p className="error">{formErrors.booth_details}</p>
                                </Form.Group>
                                </Col> */}
                                    </Row>
                                <Form.Group>
                                    <Form.Label>Intended approach / program for exhibition booth at photo l.a.? (e.g one artist,
group exhibition, 19th century, 20th century, mixed; please specify) <span className='star'>*</span> [ 1200 characters ] </Form.Label>
                                    <Form.Control maxlength="1200" as="textarea" rows={3} name="intended_approach" defaultValue={formValues.intended_approach}  onChange={hanldeChange} />
                                    <p className="error">{formErrors.intended_approach}</p>
                                </Form.Group>
                                <Form.Group>
                                    <Form.Label>Current year's gallery exhibition schedule including other Art Fair participation? <span className='star'>*</span> [ 1200 characters ] </Form.Label>
                                    <Form.Control maxlength="1200" as="textarea" rows={3} name="current_years_gallery" defaultValue={formValues.current_years_gallery}  onChange={hanldeChange} />
                                    <p className="error">{formErrors.current_years_gallery}</p>
                                </Form.Group>
                                <Form.Group>
                                    <Form.Label>List of artists proposed for photo l.a. exhibition booth? <span className='star'>*</span> [ 1200 characters ] </Form.Label>
                                    <Form.Control maxlength="1200" as="textarea" rows={3} name="list_of_artists" defaultValue={formValues.list_of_artists}  onChange={hanldeChange} />
                                    <p className="error">{formErrors.list_of_artists}</p>
                                </Form.Group>
                                <hr/>
                                <div className='text-center'>
                                <Button type="submit" onClick={handleSubmit} className='common-btn'>
                                    Continue <FontAwesomeIcon icon={faArrowRightLong} />
                                </Button>
                                </div>
                            </Form>
                        </div>
                </div>
            </div>
            </div>
            </div>
 
        </section>
        </>
    )
}